// extracted by mini-css-extract-plugin
export default {"statConn":"Doughnut_statConn__ua1Nn"};